import BaseNode from './BaseNode';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { colors } from '../../styles';

const TriggerNode = ({ data }: { data: { label: string } }) => (
  <BaseNode label={data.label} typeLabel="Gatilho" accent={colors.primary.yellow} icon={<PlayArrowIcon />} />
);

export default TriggerNode;
